<template>
  <div class="data-page">
    <el-row :gutter="20" type="flex" justify="end">
      <el-col :xl="18" :lg="16" style="display:flex;align-items:center;">
        <label style="width:70px;">{{ $t('performance-analysis::shopName') }}</label>
        <el-select v-model="selectedShop" :placeholder="$t('system::common::select_placeholder')" @change="changeShop">
          <el-option
            v-for="item in shopList"
            :key="item.shopId"
            :label="item.shopName"
            :value="item.shopId"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :xl="6" :lg="8" style="display:flex;align-items:center;">
        <label style="width:150px;">{{ $t('performance-analysis::orderDate') }}</label>
        <el-date-picker
          style="width: 100%"
          :clearable="false"
          @change="handlerDateChange"
          v-model="date"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportTable :config="salesTable" v-loading="loading.salesTable" :style="`height: ${reportHeight};`">
          <el-table-column prop="imageUrl" :label="$t('board::table_商品图片')" min-width="100px">
            <template slot-scope="scope">
              <el-image :src="scope.row.imageUrl" class="goods-image"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="spuId" :label="'spu_id'" min-width="100px"></el-table-column>
          <el-table-column prop="saleQuantity" :label="$t('board::table_销量')" min-width="100px">
            <template slot-scope="scope">
              {{ $dataCheck(scope.row.saleQuantity) }}
            </template>
          </el-table-column>
          <el-table-column prop="saleAmount" :label="$t('board::table_销售金额')" min-width="100px">
            <template slot-scope="scope">
              {{ $dataCheck(scope.row.saleAmount) }}
            </template>
          </el-table-column>
          <el-table-column prop="refundAmount" :label="$t('board::table_退款金额')" min-width="100px">
            <template slot-scope="scope">
              {{ $dataCheck(scope.row.refundAmount) }}
            </template>
          </el-table-column>
          <el-table-column prop="stockQuantity" :label="$t('board::table_可用库存数量')" min-width="120px">
            <template slot-scope="scope">
              {{ $dataCheck(scope.row.stockQuantity) }}
            </template>
          </el-table-column>
          <el-table-column prop="customerPricePer" :label="$t('board::table_客单价')" min-width="100px">
            <template slot-scope="scope">
              {{ $dataCheck(scope.row.customerPricePer) }}
            </template>
          </el-table-column>
        </reportTable>
      </el-col>

      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportCard
          :config="salesPieEchart"
          v-loading="loading.salesPieEchart"
          :style="`height: ${reportHeight};`"
        ></reportCard>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportTable :config="consumeTable" v-loading="loading.consumeTable" :style="`height: ${reportHeight};`">
          <el-table-column prop="customerName" :label="$t('board::table_顾客名称')" min-width="100px"></el-table-column>
          <el-table-column prop="orderNum" :label="$t('board::table_下单次数')" min-width="120px">
            <template slot-scope="scope">
              {{ $dataCheck(scope.row.orderNum) }}
            </template>
          </el-table-column>
          <el-table-column prop="totalAmount" :label="$t('board::table_消费总额')" min-width="120px">
            <template slot-scope="scope">
              {{ $dataCheck(scope.row.totalAmount) }}
            </template>
          </el-table-column>
          <el-table-column prop="createDate" :label="$t('board::table_加入日期')" min-width="150px">
            <template slot-scope="scope">
              {{ $dataCheck(scope.row.createDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="lastOrderDate" :label="$t('board::table_最近下单日期')" min-width="150px">
            <template slot-scope="scope">
              {{ $dataCheck(scope.row.lastOrderDate) }}
            </template>
          </el-table-column>
        </reportTable>
      </el-col>

      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportCard
          :config="buyBarEchart"
          v-loading="loading.buyBarEchart"
          :style="`height: ${reportHeight};`"
        ></reportCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from 'moment'
import { getSalesTable, getSalesPieEchart, getConsumeTable, getBuyBarEchart } from '@/server/data'
import { getShopList } from '@/server/product'
import { pickerOptions } from '@/utils/datepickerConfig'
import setConfig from './setConfig'
import dataCard from '@/components/data-analysis/card'
import reportCard from '@/components/data-analysis/report'
import reportTable from '@/components/data-analysis/table'
export default {
  components: {
    dataCard,
    reportCard,
    reportTable
  },
  mixins: [setConfig],
  data() {
    return {
      pickerOptions: {
        ...pickerOptions,
        disabledDate: time => {
          return time.getTime() >= Date.parse(new Date())
        }
      },
      date: [moment().subtract(29, 'days'), moment()],
      params: {
        startDate: moment()
          .subtract(29, 'days')
          .format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      },
      selectedShop: '',
      shopList: [],
      reportHeight: '400px',
      salesTable: [],
      salesPieEchart: {},
      consumeTable: [],
      buyBarEchart: {},
      loading: {
        salesTable: false,
        salesPieEchart: false,
        consumeTable: false,
        buyBarEchart: false
      }
    }
  },
  async mounted() {
    await this.getShopData()
    this.getAllData()
  },
  methods: {
    async getShopData() {
      const { data } = await getShopList()
      if (data.code === this.$code) {
        this.shopList = [{ shopName: this.$t('system::common::select_all'), shopId: '' }, ...data.data]
      }
    },
    getAllData() {
      this.getSalesTable()
      this.getSalesPieEchart()
      this.getConsumeTable()
      this.getBuyBarEchart()
    },
    changeShop() {
      this.getAllData()
    },
    async getSalesTable() {
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.salesTable = true
      const { data } = await getSalesTable(obj)
      const list = Array.isArray(data.data.datas) ? data.data.datas : []
      this.salesTable = this.setSalesTableConfig(list)
      this.loading.salesTable = false
    },
    async getSalesPieEchart() {
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.salesPieEchart = true
      const { data } = await getSalesPieEchart(obj)
      const list = Array.isArray(data.data.datas) ? data.data.datas : []
      this.salesPieEchart = this.setSalesPieEchartConfig(list)
      this.loading.salesPieEchart = false
    },
    async getConsumeTable() {
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.consumeTable = true
      const { data } = await getConsumeTable(obj)
      const list = Array.isArray(data.data.datas) ? data.data.datas : []
      this.consumeTable = this.setConsumeTableConfig(list)
      this.loading.consumeTable = false
    },
    async getBuyBarEchart() {
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.buyBarEchart = true
      const { data } = await getBuyBarEchart(obj)
      const list = Array.isArray(data.data.datas) ? data.data.datas : []
      this.buyBarEchart = this.setBuyBarEchartConfig(list)
      this.loading.buyBarEchart = false
    },
    handlerDateChange(date) {
      this.params.startDate = moment(date[0]).format('YYYY-MM-DD')
      this.params.endDate = moment(date[1]).format('YYYY-MM-DD')
      this.getAllData()
    }
  }
}
</script>

<style lang="scss" scoped>
.card-content {
  margin-top: 10px;
}
.card-content__total {
  position: absolute;
  font-size: 16px;
  margin-top: 16px;
}
.date-label {
  display: flex;
  justify-content: center;
  align-items: center;
}
.goods-image {
  width: 64px;
  height: 64px;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
}
</style>
